import React from "react";
import { Brand } from "./Brand";
import { links } from "../data/content";
import { shell } from "../utils/styles";
export function Footer() {
  return <footer className={`${shell}`} data-id="element-63" data-mp="3ghc508vl1fre">
      <div className="flex flex-wrap items-center justify-between gap-[22px] border-t border-[#30382a] py-7 sm:flex-nowrap sm:gap-5" data-id="element-64" data-mp="32oe303omwpev">
        <div className="w-full sm:w-auto" data-id="element-65" data-mp="36q90ex3g2ind">
          <Brand compact data-id="element-66" data-mp="3uf0nja26gata" />
        </div>
        <span className="text-[11px] text-dim" data-id="element-67" data-mp="3ug3gromz2pcd">© 2026 Marketing con Marcos</span>
        <a href={links.instagram} target="_blank" rel="noopener noreferrer" className="text-[11px] text-dim transition-colors duration-150 hover:text-lime" data-id="element-68" data-mp="39904ifsbca6">
          Consultas: @marketingconmarcos
        </a>
      </div>
    </footer>;
}